import React from "react";
import { Grid } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import FacultyCard from "../../muiCommonComponent/facultyCards";

const FacultyList=()=>{
    const facultyList=[
        {img:'/assets/img/SOL/bhanu_priya.png',name:'Bhanu Priya',position:'Assistant Professor',email:'bhanupriya.law@mvn.edu.in',
        gs: " https://scholar.google.com/citations?hl=en&user=dhu_ickaaaaj ",
        linkedin: "https://www.linkedin.com/in/bhanupriyasuneja",
        orcid: "https://orcid.org/0009-0005-1909-3088",
        rg: "https://www.researchgate.net/?_tp=eyjjb250zxh0ijp7imzpcnn0ugfnzsi6innpz251ccisinbhz2uioijzawdudxaifx0%3d",
        website: "#",
        aoi: "Certified Posh Trainer, Criminal Laws, Constitutional Law, Civil Law",
        education: "BA LLB, LLM( Specialization in Criminal Law) Ph.d (Pursuing)",
        re: "2",
        te: "2.9",
        iece: "0.6",
        articles: "2 Papers",
        books: "N/A",
        chapters: "N/A",
        patents: "N/A",
        membership: "<li>All India Bar Council </li><li>District Bar Association, Delhi </li>",
        aa1: "I.  Best Paper Award At International Conference.",
        aa2: "II. Mdu Rank Holder.",
        aa3: "III. Certified POSH Trainer. ",
        aa4: "IV. Women Cell Chairperson.",
        aa5: "V. Guest Speaker ",
        aa6: "",}, 


        {   img:'',
            name:'Rama',
            position:'Lecturer',
            email:'rama.law@mvn.edu.in',
            gs: "https://drive.google.com/file/d/1i4mnawxhpi78hv60rqwsvlb2kjtwcd-q/view?usp=drive_link",
            linkedin: "",
            orcid: "",
            rg: "",
            website: "#",
            aoi: "Criminal Law  And Code Of Civil Procedure",
            education: "BA LLB, LLM, Phd Pursuing",
            re: "4 ",
            te: "",
            iece: "0",
            articles: "3 Papers ",
            books: "",
            chapters: "",
            patents: "N/A",
            membership: "",
            aa1: "",
            aa2: "",
            aa3: "",
            aa4: "",
            aa5: "",
            aa6: "",},


             { 
                img:'/assets/img/SOL/kavita_kaushik.png',
                name:'Kavita Kaushik',
                position:'Assistant Professor',
                email:'kavita.kaushik@mvn.edu.in',
                gs: " https://scholar.google.com/citations?view_op=new_profile&hl=en",
                linkedin: " https://www.linkedin.com/in/kavita-kaushik-213944301/dIn",
                orcid: "https://orcid.org/0009-0007-1087-7585",
                rg: "https://www.researchgate.net/profile/Kavita-Kaushik-2",
                website: "#",
                aoi: "HRM, Marketing, Finance",
                education: "BBA, MBA (HRM + Finance), PhD (pursuing)",
                re: "2 ",
                te: "4.5",
                iece: "1",
                articles: "3 Papers ",
                books: "",
                chapters: "",
                patents: "N/A",
                membership: "",
                aa1: "I. Passed with distinction in MBA program.",
                aa2: "II. University Positions in B.B.A.(6th rank) & in MBA (2nd rank) ",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},


            //  {   
            //     img:'',
            //     name:'Anant Phogat',
            //     position:'Assistant Professor',
            //     email:'anant.phogat@mvn.edu.in',
            //     gs: "",
            //     linkedin: "https://www.linkedin.com/in/anant-phogat-73833a132/",
            //     orcid: "",
            //     rg: "",
            //     website: "#",
            //     aoi: "Criminal Law, Constitution & Technology Law",
            //     education: "BBA LLN(Hons.), LLM (Criminalogy)",
            //     re: "",
            //     te: "2",
            //     iece: "3",
            //     articles: "",
            //     books: "",
            //     chapters: "",
            //     patents: "N/A",
            //     membership: "",
            //     aa1: "1 Year Diploma in 'Technology Law and Fintech Regulations'",
            //     aa2: "All india bar council.  ",
            //     aa3: "District bar association, delhi",
            //     aa4: "",
            //     aa5: "",
            //     aa6: "",},


             {   img:'/assets/img/SOL/ramveer_singh.png',
                name:'Dr. Ramveer Singh',
                position:'Associate Professor',
                email:'ramveer.singh@mvn.edu.in',
                gs: "https://scholar.google.com/citations?view_op=new_articles&hl=en&imq=Dr.+Ramveer+Singh#",
                linkedin: "https://www.linkedin.com/in/dr-ramveer-singh-b96a281a6/",
                orcid: "https://orcid.org/my-orcid?orcid=0000-0002-3359-121X",
                rg: "https://www.researchgate.net/profile/Ramveer-Singh-2",
                website: "#",
                aoi: "Criminal Law, Constitutional Law, Family Law.",
                education: " PhD (Criminal Law)",
                re: "10",
                te: "15",
                iece: "0",
                articles: "24 Papers",
                books: "",
                chapters: "3 Chapters",
                patents: "N/A",
                membership: "<li>A. ALL INDIA BAR COUNCIL.</li><li>B. DISTRICT BAR ASSOCIATION, DELHI</li>",
                aa1: "",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},


             {   img:'/assets/img/SOL/kanchan.jpg',
                name:'kanchan',
                position:'Assistant Professor',
                email:'kanchan.law@mvn.edu.in',
                gs: "https://scholar.google.com/citations?view_op=new_profile&hl=en&authuser=2",
                linkedin: "https://www.linkedin.com/in/kanchan-dagar-4b328b354?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                orcid: "https://orcid.org/my-orcid?orcid=0009-0001-5075-7699&justRegistered=true",
                rg: "https://www.researchgate.net/profile/Kanchan-Dagar?ev=hdr_xprf",
                website: "#",
                aoi: "Criminal Law, Family Law, Civil Law, Evidence, Constitution",
                education: "B.Tech(ECE), LL.B., LLM(criminal law),Pursuing Ph.D",
                re: "",
                te: "1.5",
                iece: "0",
                articles: "",
                books: "",
                chapters: "",
                patents: "N/A",
                membership: "<li>A. ALL INDIA BAR COUNCIL.</li><li>B. DISTRICT BAR ASSOCIATION, Palwal</li>",
                aa1: "Qualified UGC NET exam ,appeared in judicial services (mains)examinations of different states and also appeared in Haryana ADA interview held at HPSC Commission,Panchkula.",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},


            //  {   img:'/assets/img/SOL/shivali_garg.png',
            //     name:'Shivali Garg',
            //     position:'Assistant Professor',
            //     email:'shivali.garg@mvn.edu.in',
            //     gs: "scholar.google.com/citations?view_op=new_articles&hl=en&imq=Shivali+Garg# ",
            //     linkedin: "https://linkedin.com/in/shivali-garg-a887a3301 ",
            //     orcid: "https://orcid.org/0009-0006-8712-6432",
            //     rg: "https://www.researchgate.net/profile/Shivali-Garg-2 ",
            //     website: "#",
            //     aoi: "Cyber laws, Intellectual Property Laws",
            //     education: "B.A., LL.B., LL.M., Ph.D.(Pursuing)",
            //     re: "1.5",
            //     te: "2",
            //     iece: "5",
            //     articles: "",
            //     books: "",
            //     chapters: "",
            //     patents: "N/A",
            //     membership: "<li>Member of All India Bar Council.</li>",
            //     aa1: " Received M.L.Baneja Award for securing first position in Graduation.",
            //     aa2: "",
            //     aa3: "",
            //     aa4: "",
            //     aa5: "",
            //     aa6: "",},



             {   img:'',
                name:'Arun Tyagi',
                position:'Assistant Professor',
                email:'arun.tyagi@mvn.edu.in',
                gs: "",
                linkedin: "https://www.linkedin.com/in/arun-tyagi-22b2b9344?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
                orcid: "",
                rg: "",
                website: "#",
                aoi: "Criminal Law, Civil Law",
                education: "B.A., LL.B., LL.M., Ph.D.(Pursuing)",
                re: "1",
                te: "1",
                iece: "0",
                articles: "",
                books: "",
                chapters: "",
                patents: "N/A",
                membership: "<li>A. ALL INDIA BAR COUNCIL. </li><li>B. DISTRICT BAR ASSOCIATION, FARIDABAD</li>",
                aa1: "MDU RANK HOLDER",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},


             {   img:'/assets/img/SOL/jaya_sharma.png',
                name:'Jaya Sharma',
                position:'Assistant Professor',
                email:'jayasharma.law@mvn.edu.in',
                gs: "https://scholar.google.com/citations?view_op=new_profile&hl=en",
                linkedin: "https://www.linkedin.com/in/jaya-sharma-6322b3380/",
                orcid: "https://orcid.org/my-orcid?orcid=0009-0000-0975-9169",
                rg: "https://www.researchgate.net/profile/Jaya-Sharma-33?ev=hdr_xprf&_tp=eyJjb250ZXh0Ijp7ImZpcnN0UGFnZSI6InByb2ZpbGUiLCJwYWdlIjoiaG9tZSIsInBvc2l0aW9uIjoiZ2xvYmFsSGVhZGVyIn19",
                website: "#",
                aoi: "Criminal Law, Civil Law, Human Rights, Law of Contract",
                education: "B.Com, LL.B, D.El.Ed, LL.M(Criminal Law), Ph.D(pursuing)",
                re: "",
                te: "1",
                iece: "0",
                articles: "",
                books: "",
                chapters: "",
                patents: "N/A",
                membership: "<li>Member of All India Bar Council</li> <li>Member of Delhi Bar Council</li>",
                aa1: "Central Teacher Eligibility Test (CTET), 2024 , Gold medalist in LLM",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/surbhi_tragi.png',
                name:'Surbhi Tyagi',
                position:'Assistant Professor',
                email:'surbhi.tyagi@mvn.edu.in',
                gs: "#",
                linkedin: "https://www.linkedin.com/in/surbhi-tyagi-4115131b4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                orcid: "https://orcid.org/my-orcid?orcid=0009-0008-8914-4954",
                rg: "#",
                website: "#",
                aoi: "Human Rights",
                education: "B.A.LL.B, LLM, Ph.D. Pursuing (Thesis Submitted)",
                re: "3",
                te: "N/A",
                iece: "3",
                articles: "6 Papers",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "<li>A. Member of All India Bar Council.</li> <li>B. Member of Delhi Bar Council</li>",
                aa1: "2 Conferences, Legal Quiz, Webinars, Workshops, FDP.",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/bharti_kumari.png',
                name:'Bharti kumari',
                position:'Assistant professor',
                email:'bharti.kumari@mvn.edu.in ',
                gs: "#",
                linkedin: "#",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "Criminal law ,family law",
                education: "BALLB,LLM,NET JRF",
                re: "N/A",
                te: "N/A",
                iece: "N/A",
                articles: "N/A",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "",
                aa1: "",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/drsuresh_kumar.png',
                name:'Dr. Suresh Kumar',
                position:'Associate professor',
                email:'drsuresh.kumar@mvn.edu.in',
                gs: "#",
                linkedin: "https://www.linkedin.com/in/dr-suresh-kumar-42a9a6190?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "IPR, Tax, Insurance, Legal Research, Forensic Science",
                education: "BA, B.ed, LLB, LLM, UGC Net, Ph.D",
                re: "6",
                te: "7",
                iece: "7",
                articles: "35 Papers",
                books: "13 Books",
                chapters: "4",
                patents: "10",
                membership: "<li>Punjab and Haryana Barcouncil, All India Bar Council, Bar Association Gurugram</li>",
                aa1: "40 Conferences/Seminars, 70FDPs, 20 Research Methodology Workshops,Session Chair in National Seminar, Moot Court Judge, 15 Days Refresher Course, One Month Faculty Induction Course by UGC, 1 Chief Editor in Law Journal, 8 Editorial Member in International Law Journal/Forensic Science Journal, Teaching Appreciation Award",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},


                {img:'/assets/img/SOL/malti_bhati.png',
                name:'Ms. Malti Bhati ',
                position:'Lecturer',
                email:'malti.bhati@mvn.edu.in',
                gs: "#",
                linkedin: "#",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "Constitutional law",
                education: "BBA,MBA,LLB,LLM,PHD Pursuing",
                re: "N/A",
                te: "N/A",
                iece: "N/A",
                articles: "N/A",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "",
                aa1: "",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/pushpa_gupta.png',
                name:'Ms. Pushpa Gupta',
                position:'Lecturer',
                email:'pushpa.gupta@mvn.edu.in',
                gs: "#",
                linkedin: "#",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "Criminal Law",
                education: "BA (H.), PGDHRM, LLB, LLM, Ph.D. Pursuing ",
                re: "N/A",
                te: "N/A",
                iece: "N/A",
                articles: "N/A",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "",
                aa1: "",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/vikash_kabeer.png',
                name:'Mr. Vikas Kabeer',
                position:'Assistant Professor',
                email:'vikas.kabeer@mvn.edu.in',
                gs: "#",
                linkedin: "#",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "Corporate Law, IPR, Environmental Law",
                education: "BA. LL.B., LL.M. UGC-NET, Ph.D. Pursuing",
                re: "N/A",
                te: "N/A",
                iece: "N/A",
                articles: "5 Paper",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "<li>A. BAR COUNCIL OF INDIA. </li><li>B. BAR COUNCIL OF PUNJAB & HARYANA</li><li>C. DISTRICT BAR ASSOCIATION PALWAL</li>",
                aa1: "1. Certifications - AIBE, CCC, AI & Law, Creative & Feature Writing.",
                aa2: "2. Workshops on Litigation, AI & Law.",
                aa3: "3. Public Orator & Content Creator (YouTube)  ",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/krishna_puri.png',
                name:'Mr. Krishna Puri',
                position:'Assistant Professor',
                email:'krishna.puri@mvn.edu.in',
                gs: "#",
                linkedin: "#",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "Criminal Law, BNS, ADR, Penology & Victimology ",
                education: "BA. LL.B., LL.M. Ph.D. Pursuing",
                re: "N/A",
                te: "N/A",
                iece: "N/A",
                articles: "N/A",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "",
                aa1: "",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},

                {img:'/assets/img/SOL/krishna_puri.png',
                name:'Mr. Tarun Gaur',
                position:'Assistant Professor',
                email:'tarun.gaur@mvn.edu.in',
                gs: "#",
                linkedin: "#",
                orcid: "#",
                rg: "#",
                website: "#",
                aoi: "Constitutional law of india,Indian Contract Act,Family law,ADR,BNS,Administrative law,etc",
                education: "",
                re: "N/A",
                te: "N/A",
                iece: "N/A",
                articles: "N/A",
                books: "N/A",
                chapters: "N/A",
                patents: "N/A",
                membership: "",
                aa1: "",
                aa2: "",
                aa3: "",
                aa4: "",
                aa5: "",
                aa6: "",},
                
                // {   img:'/assets/img/SOL/sachin_sharma.png',
                //     name:'Sachin Sharma ',
                //     position:'Assistant professor ',
                //     email:'sachin.sharma@mvn.edu.in',
                //     gs: "https://scholar.google.com/citations?view_op=new_articles&hl=en&imq=sachin+sharma%23",
                //     linkedin: "",
                //     orcid: "https://orcid.org/0000-0002-5644-1310",
                //     rg: "https://www.researchgate.net/profile/Sachin-Sharma-122",
                //     website: "#",
                //     aoi: "constitutional law ",
                //     education: "LLM, PhD (Law Perusing)",
                //     re: "2",
                //     te: "2",
                //     iece: "4",
                //     articles: "",
                //     books: "",
                //     chapters: "",
                //     patents: "N/A",
                //     membership: "<li>Qualified UGC Net (2018)</li><li>Gold Medalist in LLM</li>",
                //     aa1: "Mr Sachin Sharma & Dr. Rahul Varshney., Digital Discourse : A Look on Social Media Regulations ”International Reserch Mirror, Vol-1. Issue-11, Nov-2023,",
                //     aa2: "Mr Sachin Sharma & Dr. Rahul Varshney., Executive Legislation in India:Legality of ordinance Making Power Praxis International vol. 6 issue 8, Aug-2023 DoI No. 10.51879/PIJSL/060819",
                //     aa3: "",
                //     aa4: "",
                //     aa5: "",
                //     aa6: "",},

             /*{   img:'',
            name:'',
            position:'',
            email:'',
            gs: "",
            linkedin: "",
            orcid: "",
            rg: "",
            website: "#",
            aoi: "",
            education: "",
            re: "",
            te: "",
            iece: "0",
            articles: "",
            books: "",
            chapters: "",
            patents: "N/A",
            membership: "",
            aa1: "",
            aa2: "",
            aa3: "",
            aa4: "",
            aa5: "",
            aa6: "",},*/


    ]
return(
    <Grid container spacing={2} sx={{margin:'10px 0px'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <MainTitle title='School of Law Faculties'/>
        </Grid>
        {facultyList?.map((fac)=>(
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <FacultyCard faculty={fac} />
        </Grid>
        ))}

        
    </Grid>
    
)
}
export default FacultyList;